import React from 'react';
import { Center, Spinner } from '@chakra-ui/react';
import { useOktaAuth } from '@okta/okta-react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';

export const ProtectedRoute: React.FC = () => {
  const { authState } = useOktaAuth();
  const location = useLocation();

  if (!authState || authState.isPending) {
    return (
      <Center h="100vh">
        <Spinner size="xl" />
      </Center>
    );
  }

  if (!authState.isAuthenticated) {
    // Store current path for deep linking
    const fullPath = location.pathname + location.search;
    const isValidPath = fullPath.length <= 2048 &&
                       location.pathname.startsWith('/') && 
                       !location.pathname.includes('://') && 
                       !location.pathname.startsWith('//') &&
                       !location.pathname.includes('..') &&
                       !location.pathname.includes('/admin');
    
    if (isValidPath && !location.pathname.includes('/callback') && location.pathname !== '/login') {
      try {
        sessionStorage.setItem('redirectPath', fullPath);
      } catch (e) {
        // Storage failed, continue without storing
      }
    }
    
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <Outlet />;
};